export default __webpack_public_path__ + "static/media/icon-food.34a16e16.svg";